import {
  AccountInfo,
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

let eventsRegistered = false;

const resolveEventAccount = (event: EventMessage): AccountInfo | null => {
  if (event.eventType !== EventType.LOGIN_SUCCESS) {
    return null;
  }

  const payload = event.payload as AuthenticationResult | null;
  return payload?.account || null;
};

export const setupMsalClient = () => {
  const bootstrapAccounts = msalInstance.getAllAccounts();
  if (!msalInstance.getActiveAccount() && bootstrapAccounts.length > 0) {
    // Keep bootstrap behavior stable by selecting the first cached account.
    msalInstance.setActiveAccount(bootstrapAccounts[0]);
  }

  if (eventsRegistered) {
    return;
  }

  msalInstance.addEventCallback((event) => {
    const account = resolveEventAccount(event);
    if (account) {
      msalInstance.setActiveAccount(account);
    }
  });

  eventsRegistered = true;
};

